/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Severity change details including new severity and reason
 * @export
 * @interface SeverityChangeRequest
 */
export interface SeverityChangeRequest {
    /**
     * New severity level for the case
     * @type {string}
     * @memberof SeverityChangeRequest
     */
    severity: SeverityChangeRequestSeverityEnum;
    /**
     * Reason for the severity change
     * @type {string}
     * @memberof SeverityChangeRequest
     */
    reason?: string;
    /**
     * Additional notes about the severity change
     * @type {string}
     * @memberof SeverityChangeRequest
     */
    notes?: string;
    /**
     * Whether to create a timeline event for this severity change
     * @type {boolean}
     * @memberof SeverityChangeRequest
     */
    createTimelineEvent?: boolean;
}


/**
 * @export
 */
export const SeverityChangeRequestSeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type SeverityChangeRequestSeverityEnum = typeof SeverityChangeRequestSeverityEnum[keyof typeof SeverityChangeRequestSeverityEnum];


/**
 * Check if a given object implements the SeverityChangeRequest interface.
 */
export function instanceOfSeverityChangeRequest(value: object): value is SeverityChangeRequest {
    if (!('severity' in value) || value['severity'] === undefined) return false;
    return true;
}

export function SeverityChangeRequestFromJSON(json: any): SeverityChangeRequest {
    return SeverityChangeRequestFromJSONTyped(json, false);
}

export function SeverityChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SeverityChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'severity': json['severity'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createTimelineEvent': json['createTimelineEvent'] == null ? undefined : json['createTimelineEvent'],
    };
}

export function SeverityChangeRequestToJSON(json: any): SeverityChangeRequest {
    return SeverityChangeRequestToJSONTyped(json, false);
}

export function SeverityChangeRequestToJSONTyped(value?: SeverityChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'severity': value['severity'],
        'reason': value['reason'],
        'notes': value['notes'],
        'createTimelineEvent': value['createTimelineEvent'],
    };
}

